import api, { ApiResponse } from './index'

export interface PopularSkillsResponse {
    skills: string[]
    totalSkills: number
}

export const popularSkillsApi = {
    // Get popular skills from gigs (public endpoint)
    getPopularSkills: (limit?: number): Promise<ApiResponse<PopularSkillsResponse>> =>
        api.get('/gigs/popular-skills', {
            params: limit ? { limit } : undefined
        }),
}